import { EditAddressModalMobileState } from './types';

export const initialState: EditAddressModalMobileState = {
  isOpenModal: false,
};
